export default __webpack_public_path__ + "static/media/update-history-icon.ee75bd3a.svg";